import { DirectiveBinding } from 'vue'

export default {
  beforeMount(el: HTMLElement, binding: DirectiveBinding<string>) {
    const urlRegex = /(https?:\/\/[^\s]+)/g // www zorunluluğu kaldırıldı
    if (binding.value) {
      el.innerHTML = binding.value.replace(
        urlRegex,
        `<a href="$1" target="_blank" rel="noopener noreferrer" class="text-sm line-clamp-1" style="text-decoration: underline;">$1</a>`
      )
    }
  },
  updated(el: HTMLElement, binding: DirectiveBinding<string>) {
    const urlRegex = /(https?:\/\/[^\s]+)/g // www zorunluluğu kaldırıldı
    if (binding.value) {
      el.innerHTML = binding.value.replace(
        urlRegex,
        `<a href="$1" target="_blank" rel="noopener noreferrer" class="text-sm line-clamp-1" style=" text-decoration: underline;">$1</a>`
      )
    }
  }
}
